import { render, staticRenderFns } from "./VeColumnSettings.vue?vue&type=template&id=37b0f408"
import script from "./VeColumnSettings.vue?vue&type=script&lang=js"
export * from "./VeColumnSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports